export default "__VITE_ASSET__fbeba2c2__"